import React from "react";
import InputForm from "../../svg/inputform.svg";
import { buildImageObj } from "../../lib/helpers";
import { imageUrlFor } from "../../lib/image-url";

export const Partners = ({ partners }) => {

  return (
    <>
      <div className="infoCardHeader--grid">
        <div className="infoCardHeader--wrapper">
          <div className="infoCardHeaderIcon--grid">
            <div className="icon--background">
              <InputForm />
            </div>
            <h1>{partners.title}</h1>
          </div>
        </div>
        <hr className="rounded" />
      </div>
      <p>{partners.infotext}</p>
      <div className="partners__wrapper">
        {partners.partnersList.map((partner, index) => {
          return (
            <a href={partner.url} target="_blank" rel="noreferrer" key={index}>
              <div className="partners__partner">
                <img
                  src={imageUrlFor(buildImageObj(partner.logo)).url()}
                  title={partner.logo.alt}
                  alt={partner.logo.alt}
                  caption={partner.logo.alt}
                />
              </div>
            </a>
          );
        })}
      </div>
    </>
  );
};
